export default __webpack_public_path__ + "static/signets-d5688ff164440d9b20b118cbcb04ffa4.png";